<script setup lang="ts">
import { company } from '~/data/company'
import type { Locale } from '~/data/types'

const { t, locale } = useI18n()
const lc = computed(() => locale.value as Locale)
const crumbs = usePageMeta('imprint')
</script>

<template>
  <div>
    <PageHeader
      :title="t('imprint.title')"
      :crumbs="crumbs"
    />
    <div class="container-site section pt-6">
      <div class="prose-dg">
        <h2>{{ t('imprint.provider') }}</h2>
        <p>
          {{ company.owner }}<br>
          {{ company.name }}<br>
          {{ company.street }}<br>
          {{ company.zip }} {{ company.city }}<br>
          {{ company.country[lc] }}
        </p>
        <h2>{{ t('imprint.contact') }}</h2>
        <p>
          {{ t('contact.phone') }}: {{ company.phone }}<br>
          {{ t('imprint.fax') }}: {{ company.fax }}<br>
          {{ t('contact.email') }}: <a :href="`mailto:${company.email}`">{{ company.email }}</a>
        </p>
        <h2>{{ t('imprint.vat') }}</h2>
        <p>{{ company.vatId || t('imprint.vatMissing') }}</p>
        <h2>{{ t('imprint.responsible') }}</h2>
        <p>{{ company.owner }}, {{ t('contact.address') }} {{ t('imprint.asAbove') }}</p>
        <h2>{{ t('imprint.dispute') }}</h2>
        <p>{{ t('imprint.disputeText') }}</p>
        <h2>{{ t('imprint.liabilityTitle') }}</h2>
        <p>{{ t('imprint.liabilityText') }}</p>
        <h2>{{ t('imprint.copyrightTitle') }}</h2>
        <p>{{ t('imprint.copyrightText') }}</p>
      </div>
    </div>
  </div>
</template>
